import { ChainId } from '@pancakeswap/sdk'
// import FarmsBscPriceHelper from './56'
// import FarmsBscTestnetPriceHelper from './97'
// import FarmsEthereumPriceHelper from './1'
// import FarmsGoerliPriceHelper from './5'
import FarmsMantlePriceHelper from './5000'
import FarmsMantleTestnetPriceHelper from './5003'

export const getFarmsPriceHelperLpFiles = (chainId: ChainId) => {
  switch (chainId) {
    case ChainId.MANTLE:
      return FarmsMantlePriceHelper;
    case ChainId.MANTLE_TESTNET:
      return FarmsMantleTestnetPriceHelper;
    default:
      return []
  }
}
